/**
 * _tiptap.js — load the Tiptap editor module on demand.
 *
 * The editor lives outside the controllers bundle (see ../tiptap.entry.js), so
 * the editor controllers await loadTiptap() before building an Editor.
 * __TIPTAP_MODULE_URL__ is replaced at build time by scripts/build-controllers.mjs
 * with the module's content-hashed path, which is what keeps a browser or the
 * service worker from pairing a new bundle with an old editor build.
 *
 * One promise per page: the first caller starts the fetch and every later
 * caller shares it. A failed load clears the promise so a later connect can
 * retry, rather than every editor on the page staying dead until reload.
 */

let pending = null;

export function loadTiptap() {
  if (!pending) {
    // biome-ignore lint/correctness/noUndeclaredVariables: replaced by esbuild `define`
    pending = import(__TIPTAP_MODULE_URL__).catch((error) => {
      pending = null;
      throw error;
    });
  }
  return pending;
}
